import { ID } from '..';
import { Templates } from '../../compile';
import { ViewOptions } from '../../interfaces/options';

export const DefaultViewOptions: ViewOptions = {
	viewId: ID.Dynamic,
	template: Templates.layouts_base_form_wrapper,
	navigationLayout: Templates.general_empty,
	defaultView: null,
	visible: true,
	isFullHeight: false
};
